import { useCallback, useMemo } from "react";

import debounce from "lodash.debounce";
import { Column } from "@bridgesplit/ui";

import LoopLeverageSlider from "./LoopLeverageSlider";
import { useLoopContext } from "../LoopContext";
import { useWindContext } from "./WindContext";
import { floorAndClamp } from "./util";

export default function WindMultiplier() {
    const {
        form: { multiplierWithoutDebounce },
        setForm,
        isMultiplierDisabled
    } = useWindContext();
    const { loopExpanded } = useLoopContext();
    const maxLeverageValue = loopExpanded?.loopVault.maxLeverage ?? 1;

    const handleChange = useCallback(
        (multiplier: number) =>
            setForm((prev) => ({
                ...prev,
                multiplier: floorAndClamp(multiplier, maxLeverageValue)
            })),
        [setForm, maxLeverageValue]
    );

    const setValueDebounced = useMemo(() => debounce(handleChange, 300), [handleChange]);

    return (
        <Column>
            <LoopLeverageSlider
                multiplierWithoutDebounce={multiplierWithoutDebounce}
                maxLeverageValue={maxLeverageValue}
                onMultiplierWithoutDebounceChange={(multiplier) => {
                    setForm((prev) => ({
                        ...prev,
                        multiplierWithoutDebounce: multiplier
                    }));
                }}
                onMultiplierDebouncedChange={setValueDebounced}
                disabled={isMultiplierDisabled}
            />
        </Column>
    );
}
